import { useMutation } from 'react-query';

import { axios } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';
import { CardsResponse } from '../types';

type CardProps = {
  customerId: string;
};
export const getCustomerPaymentCards = ({ customerId }: CardProps): Promise<CardsResponse> => {
  return axios.get(`/business/customers/${customerId}/cards`);
};

type UseUpdateBusinessOptions = {
  config?: MutationConfig<typeof getCustomerPaymentCards>;
};

export const useGetCustomerPaymentCards = ({ config }: UseUpdateBusinessOptions = {}) => {
  return useMutation({
    ...config,
    mutationFn: getCustomerPaymentCards,
  });
};
